import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=7ae4e250&scoped=true&"
import script from "./Competitors.vue?vue&type=script&lang=js&"
export * from "./Competitors.vue?vue&type=script&lang=js&"
import style0 from "./Competitors.vue?vue&type=style&index=0&id=7ae4e250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae4e250",
  null
  
)

/* custom blocks */
import block0 from "./Competitors.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports